import { apiGet } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

export async function getExtractDisclaimer(
  id: string | null,
  decision: string | null,
  aGuid: string | null,
  pGuid: string | null,
  v: string | null,
): Promise<string> {
  const params = new URLSearchParams();

  if (id) params.append('id', id);
  if (decision) params.append('decision', decision);
  if (aGuid) params.append('a_guid', aGuid);
  if (pGuid) params.append('p_guid', pGuid);
  if (v) params.append('v', v);

  return apiGet<string>(`${config.server}/inspections/extract/disclaimer?${params.toString()}`);
}
